import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table } from "antd";
import {
  Avatar_06,
  Avatar_07,
  Avatar_14,
  Avatar_18,
  Avatar_19,
  Avatar_22,
  Avatar_26,
  Avatar_29,
} from "../../../Routes/ImagePath";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
import SearchBox from "../../../components/SearchBox";
import Breadcrumbs from "../../../components/Breadcrumbs";
import ClientsFilter from "../../../components/ClientsFilter";
import { CustomerModal } from "./CustomerModal";
import CustomerFilter from "./CustomerFilter";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import CustomerVisitDeleteModal from "../../../components/modelpopup/CustomerVisitDeleteModal";
import moment from "moment";

const CustomerList = () => {
  const [data, setData] = useState([]);

  const CustomerData = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/CustomerVisit?UserId=${userId}&PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      console.log("done", response.data?.data);
      setData(response?.data?.data);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    CustomerData();
  }, []);

  const [deleteId, setDeleteId] = useState(null);
  const CustomerVisitDeleteFunc = async () => {
    try {
      const response = await axios.delete(
        `${Api_Url}api/v1/CustomerVisit/${deleteId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      CustomerData();
    } catch (error) {
      return error.message;
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to="/profile" className="avatar">
            <img alt="" src={record.selfieUrl} />
          </Link>
          <Link to="/profile">{text}</Link>
        </span>
      ),
    },
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },
    {
      title: "Application Number",
      dataIndex: "applicationNo",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
    },

    {
      title: "Last Activity",
      dataIndex: "",
      render: (text, record) => (
        <span className="table-avatar">
          {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      ),
    },
    {
      title: "Location",
      dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
      render: (text, record) => (
        <a
          href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-solid fa-location-dot"></i>
        </a>
      ),
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mb-0">Customer Visit</h3>
              <div>
                <button className="btn border me-3">
                  <Link to="#" className="list-view btn btn-link">
                    <i className="las la-file-export" />
                    Export
                  </Link>
                </button>
                <button
                  className="btn btn-primary submit-btn mb-2"
                  onClick={handleOpenModal}
                >
                  Add Customer Visit
                </button>
                {isModalOpen && (
                  <CustomerModal
                    onClose={handleCloseModal}
                    customerVisitDataFunc={CustomerData}
                  />
                )}
              </div>
            </div>
          </div>

          {/* <div className="page-header">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h3 className="page-title">Customer Visit</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Customer Visit</li>
                </ul>
              </div>
              <div className="col-md-8 float-end ms-auto">
                <div className="d-flex title-head">
                  <div className="view-icons">
                    <div className="form-sort">
                      <Link to="#" className="list-view btn btn-link">
                        <i className="las la-file-export" />
                        Export
                      </Link>
                    </div>
                  </div>
                  <Breadcrumbs
                    modal="#add_client"
                    name="Add Customer Visit"
                    Linkname="/clients"
                    Linkname1="/clients-list"
                  />
                </div>
              </div>
            </div>
          </div> */}
          {/* <CustomerFilter /> */}
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="table-responsive">
                <SearchBox />
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={data}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <CustomerModal customerVisitDataFunc={CustomerData} /> */}
      <CustomerVisitDeleteModal
        Name="Delete Client"
        customerDeleteFunction={CustomerVisitDeleteFunc}
      />
    </>
  );
};

export default CustomerList;
